'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PackageSelectionCardUnselected = require('./PackageSelectionCardUnselected.js');
var PackageSelectionCardSelected = require('../../../../common/views/PackageSelection/PackageSelectionCardSelected.js');
var PackageSelectionProvider = require('../../../../common/views/PackageSelection/PackageSelectionProvider.js');
var PackageSelectionSelectableCard = require('../../../../common/views/PackageSelection/PackageSelectionSelectableCard.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageSelectionCard = _ref => {
  let {
    shipment
  } = _ref;
  const {
    packageClaims
  } = PackageSelectionProvider.usePackageSelection();
  const claimDetails = packageClaims[shipment.id];
  const isSelected = Boolean(claimDetails);
  const isEligible = shipment.evaluatedEligibility.isEligible;
  return /*#__PURE__*/React__default["default"].createElement(PackageSelectionSelectableCard["default"], {
    shipment: shipment,
    selected: isSelected,
    readOnly: isSelected || !isEligible
  }, isSelected ? /*#__PURE__*/React__default["default"].createElement(PackageSelectionCardSelected["default"], {
    shipment: shipment
  }) : /*#__PURE__*/React__default["default"].createElement(PackageSelectionCardUnselected["default"], {
    shipment: shipment
  }));
};

exports["default"] = PackageSelectionCard;
